import Accordion from "react-bootstrap/Accordion";
import PropTypes from "prop-types";
import DOMPurify from "dompurify";
import { marked } from "marked";

/**
 * Accordion component displaying collapsible sections with markdown content support
 * Renders multiple accordion items with sanitized HTML from markdown text
 *
 * @component
 * @param {Object} props
 * @param {Array} props.accordionData - Array of accordion section data
 * @param {number} props.accordionData[].id - Accordion item ID
 * @param {string} props.accordionData[].titulo - Accordion item title
 * @param {string} props.accordionData[].texto - Accordion item markdown text content
 */
function AccordionComponent({ accordionData }) {
  return (
    <Accordion>
      {accordionData.map((accordion) => (
        <Accordion.Item eventKey={accordion.id.toString()} key={accordion.id} className="mb-20">
          <Accordion.Header className="panel-heading">
            <div className="AccordionHeader">{accordion.titulo}</div>
          </Accordion.Header>
          <Accordion.Body>
            <div
              className="AccordionBody"
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(marked(accordion.texto)),
              }}
            />
          </Accordion.Body>
        </Accordion.Item>
      ))}
    </Accordion>
  );
}
export default AccordionComponent;

AccordionComponent.propTypes = {
  accordionData: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      titulo: PropTypes.string.isRequired,
      texto: PropTypes.string.isRequired,
    })
  ).isRequired,
};
